define('home/models/ChannelProfileFeed',[
    'underscore',

    'core/api',
    'core/UniqueModel',

    'home/collections/ChannelProfileCollection',

    'home/models/Feed',
], function (
    _,

    api,
    UniqueModel,

    ChannelProfileCollection,

    Feed
) {
    'use strict';

    var ChannelProfileFeed = Feed.extend({
        // `listName` is a param passed to the channels/list API endpoint
        // which retrieves a unique collection of channels
        idAttribute: 'listName',

        initialize: function (attrs, options) {
            options = _.extend({
                // Define `collectionClass` and `collectionUrl` here because this
                // feed is uniquely bound to the `listName` attribute which is only
                // supported by the channels/list endpoint. Specifying a different
                // collectionClass wouldn't work if you were retrieving an existing
                // instance of this Feed anyways.
                collectionClass: ChannelProfileCollection,
                collectionUrl: api.getURL('channels/list'),
            }, options);

            Feed.prototype.initialize.call(this, attrs, options);

            this.set('fetchOptions', _.extend({
                listName: this.get('listName'),
                attach: 'counters',
            }, this.get('fetchOptions')));
        },
    }, {
        LIST_NAMES: {
            promoted: 'promoted',
            explore: 'explore',
        },
    });

    UniqueModel.addType('ChannelProfileFeed', ChannelProfileFeed);

    return ChannelProfileFeed;
});

